export { default, links, meta } from "/Users/kjensen/Sync/Learning/JavaScript/react-group-learn/etcpasswd/src/root.tsx";